import { shallowRef } from 'vue';
import { defineStore } from 'pinia';

const useAppStore = defineStore('app', () => {
  const sidebarOpen = shallowRef(false);

  const toggleSidebar = () => {
    sidebarOpen.value = !sidebarOpen.value;
  };

  const closeSidebar = () => {
    sidebarOpen.value = false;
  };

  return {
    sidebarOpen,
    toggleSidebar,
    closeSidebar,
  };
});

export default useAppStore;
